@for (item of actions; track item) {
  @if (checkIsVisible(item) === true) {
    <button [attr.data-test-name]="item.identifier" [disabled]="checkIsLoading(item) || checkDisabled(item)"
      mat-raised-button [color]="item.color" type="submit" (click)="itemClick(item)" ngStyle.xs="margin-bottom: 12px; min-width: 150px">
      <div fxLayout fxLayoutGap="12px">
        <div fxFlex="1 0 auto">
          {{ item.displayName }}
        </div>
        @if (checkIsLoading(item)) {
          <div fxFlex="0 1 auto" style="padding-top: 8px;">
            <mat-spinner [diameter]="20"></mat-spinner>
          </div>
        }
      </div>
    </button>
  }
}